import {
  OPERATOR_TYPES_1,
  OPERATOR_TYPES_2,
  OPERATOR_TYPES_3,
  OPERATOR_TYPES_6,
  OPERATOR_TYPES_LEAD_QUALITY_SCORE,
  OPERATOR_TYPES_MEETING_TIME,
} from './operators';

export const AUTOMATIONS = {
  message_created: {
    conditions: [
      {
        key: 'message_type',
        name: 'Message Type',
        attributeI18nKey: 'MESSAGE_TYPE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'content',
        name: 'Message Content',
        attributeI18nKey: 'MESSAGE_CONTAINS',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'Inbox',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'Conversation Language',
        attributeI18nKey: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'Phone Number',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'board_id',
        name: 'Board',
        attributeI18nKey: 'BOARD',
        inputType: 'search_select',
        filterOperators:  OPERATOR_TYPES_1,
      },
      {
        key: 'city',
        name: 'City',
        attributeI18nKey: 'CITY',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'conversation_labels',
        name: 'Conversation Labels',
        attributeI18nKey: 'CONVERSATION_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'lead_quality_score',
        name: 'Lead quality score',
        attributeI18nKey: 'LEAD_QUALITY_SCORE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_LEAD_QUALITY_SCORE,
        featureFlag: 'lead_quality',
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'Assign to agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'Assign a team',
        attributeI18nKey: 'ASSIGN_TEAM',
      },
      {
        key: 'add_conversation_label',
        name: 'Add a label to conversation',
        attributeI18nKey: 'ADD_LABEL',
      },
      {
        key: 'add_contact_label',
        name: 'Add a labelto contact',
        attributeI18nKey: 'ADD_LABEL',
      },
      {
        key: 'send_email_to_team',
        name: 'Send an email to team',
        attributeI18nKey: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'Send a message',
        attributeI18nKey: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'Send an email transcript',
        attributeI18nKey: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'Mute conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'Snooze conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },

      {
        key: 'resolve_conversation',
        name: 'Resolve conversation',
        attributeI18nKey: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'Send Webhook Event',
        attributeI18nKey: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'Send Attachment',
        attributeI18nKey: 'SEND_ATTACHMENT',
      },
    ],
  },
  conversation_created: {
    conditions: [
      {
        key: 'status',
        name: 'Status',
        attributeI18nKey: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'Browser Language',
        attributeI18nKey: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'Country',
        attributeI18nKey: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'Phone Number',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'referer',
        name: 'Referrer Link',
        attributeI18nKey: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'Inbox',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'Conversation Language',
        attributeI18nKey: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'Priority',
        attributeI18nKey: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'city',
        name: 'City',
        attributeI18nKey: 'ity',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'branch',
        name: 'Branch',
        attributeI18nKey: 'BRANCH',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'conversation_labels',
        name: 'Conversation Labels',
        attributeI18nKey: 'CONVERSATION_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'lead_quality_score',
        name: 'Lead quality score',
        attributeI18nKey: 'LEAD_QUALITY_SCORE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_LEAD_QUALITY_SCORE,
        featureFlag: 'lead_quality',
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'Assign to agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'Assign a team',
        attributeI18nKey: 'ASSIGN_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'Assign an agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'Send an email to team',
        attributeI18nKey: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'Send a message',
        attributeI18nKey: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'Send an email transcript',
        attributeI18nKey: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'Mute conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'Snooze conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'Resolve conversation',
        attributeI18nKey: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'Send Webhook Event',
        attributeI18nKey: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'Send Attachment',
        attributeI18nKey: 'SEND_ATTACHMENT',
      },
      {
        key: 'add_board',
        name: 'Add a Board',
        attributeI18nKey: 'ADD_BOARD',
      },
    ],
  },
  conversation_updated: {
    conditions: [
      {
        key: 'status',
        name: 'Status',
        attributeI18nKey: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'Browser Language',
        attributeI18nKey: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'Country',
        attributeI18nKey: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'Referrer Link',
        attributeI18nKey: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'Phone Number',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'assignee_id',
        name: 'Assignee',
        attributeI18nKey: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'Team',
        attributeI18nKey: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'Inbox',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'Conversation Language',
        attributeI18nKey: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'Priority',
        attributeI18nKey: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'city',
        name: 'City',
        attributeI18nKey: 'CITY',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'conversation_labels',
        name: 'Conversation Labels',
        attributeI18nKey: 'CONVERSATION_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'lead_quality_score',
        name: 'Lead quality score',
        attributeI18nKey: 'LEAD_QUALITY_SCORE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_LEAD_QUALITY_SCORE,
        featureFlag: 'lead_quality',
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'Assign to agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'Assign a team',
        attributeI18nKey: 'ASSIGN_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'Assign an agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'Send an email to team',
        attributeI18nKey: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'Send a message',
        attributeI18nKey: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'Send an email transcript',
        attributeI18nKey: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'Mute conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'Snooze conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'Resolve conversation',
        attributeI18nKey: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'Send Webhook Event',
        attributeI18nKey: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'Send Attachment',
        attributeI18nKey: 'SEND_ATTACHMENT',
      },
    ],
  },
  conversation_opened: {
    conditions: [
      {
        key: 'browser_language',
        name: 'Browser Language',
        attributeI18nKey: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'Country',
        attributeI18nKey: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'Referrer Link',
        attributeI18nKey: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'Assignee',
        attributeI18nKey: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'Phone Number',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'team_id',
        name: 'Team',
        attributeI18nKey: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'Inbox',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'Conversation Language',
        attributeI18nKey: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'Priority',
        attributeI18nKey: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'city',
        name: 'City',
        attributeI18nKey: 'CITY',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'conversation_labels',
        name: 'Conversation Labels',
        attributeI18nKey: 'CONVERSATION_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'lead_quality_score',
        name: 'Lead quality score',
        attributeI18nKey: 'LEAD_QUALITY_SCORE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_LEAD_QUALITY_SCORE,
        featureFlag: 'lead_quality',
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'Assign to agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'Assign a team',
        attributeI18nKey: 'ASSIGN_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'Assign an agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'Send an email to team',
        attributeI18nKey: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'Send a message',
        attributeI18nKey: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'Send an email transcript',
        attributeI18nKey: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'Mute conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'Snooze conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'Send Webhook Event',
        attributeI18nKey: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'Send Attachment',
        attributeI18nKey: 'SEND_ATTACHMENT',
      },
    ],
  },
  lead_quality_score_generated: {
    conditions: [
      {
        key: 'status',
        name: 'Status',
        attributeI18nKey: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_id',
        name: 'Inbox',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'board_id',
        name: 'Board',
        attributeI18nKey: 'BOARD',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'lead_quality_score',
        name: 'Lead quality score',
        attributeI18nKey: 'LEAD_QUALITY_SCORE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_LEAD_QUALITY_SCORE,
        featureFlag: 'lead_quality',
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'Assign to agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'Assign a team',
        attributeI18nKey: 'ASSIGN_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'Assign an agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'Send an email to team',
        attributeI18nKey: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'Send a message',
        attributeI18nKey: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'Send an email transcript',
        attributeI18nKey: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'Mute conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'Snooze conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'Resolve conversation',
        attributeI18nKey: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'Send Webhook Event',
        attributeI18nKey: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'Send Attachment',
        attributeI18nKey: 'SEND_ATTACHMENT',
      },
      {
        key: 'add_macro',
        name: 'Add a macro',
        attributeI18nKey: 'ADD_MACRO',
      },
    ],
  },
  board_status_change: {
    conditions: [
      {
        key: 'status',
        name: 'Status',
        attributeI18nKey: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_id',
        name: 'Inbox',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'board_id',
        name: 'Board',
        attributeI18nKey: 'BOARD',
        inputType: 'search_select',
        filterOperators:  OPERATOR_TYPES_1,
      },
      {
        key: 'lead_quality_score',
        name: 'Lead quality score',
        attributeI18nKey: 'LEAD_QUALITY_SCORE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_LEAD_QUALITY_SCORE,
        featureFlag: 'lead_quality',
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'Assign to agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'Assign a team',
        attributeI18nKey: 'ASSIGN_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'Assign an agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'Send an email to team',
        attributeI18nKey: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'Send a message',
        attributeI18nKey: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'Send an email transcript',
        attributeI18nKey: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'Mute conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'Snooze conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'Resolve conversation',
        attributeI18nKey: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'Send Webhook Event',
        attributeI18nKey: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'Send Attachment',
        attributeI18nKey: 'SEND_ATTACHMENT',
      },
      {
        key: 'add_macro',
        name: 'Add a macro',
        attributeI18nKey: 'ADD_MACRO',
      }, 
    ],
  },
  contact_joined_meeting: {
    conditions: [
      {
        key: 'meeting_present',
        name: 'Meeting is present',
        attributeI18nKey: 'MEETING_PRESENT',
        inputType: 'meeting_present',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'meeting_time',
        name: 'Meeting time',
        attributeI18nKey: 'MEETING_TIME',
        inputType: 'datetime',
        filterOperators: OPERATOR_TYPES_MEETING_TIME,
      },
      {
        key: 'guest_name',
        name: 'Guest name',
        attributeI18nKey: 'GUEST_NAME',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'status',
        name: 'Status',
        attributeI18nKey: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_id',
        name: 'Inbox',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'board_id',
        name: 'Board',
        attributeI18nKey: 'BOARD',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'lead_quality_score',
        name: 'Lead quality score',
        attributeI18nKey: 'LEAD_QUALITY_SCORE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_LEAD_QUALITY_SCORE,
        featureFlag: 'lead_quality',
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'Assign to agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'Assign a team',
        attributeI18nKey: 'ASSIGN_TEAM',
      },
      {
        key: 'send_email_to_team',
        name: 'Send an email to team',
        attributeI18nKey: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'Send a message',
        attributeI18nKey: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'Send an email transcript',
        attributeI18nKey: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'Mute conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'Snooze conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'Resolve conversation',
        attributeI18nKey: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'Send Webhook Event',
        attributeI18nKey: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_kivo_notification',
        name: 'Send Kivo Chat Notification',
        attributeI18nKey: 'SEND_KIVO_NOTIFICATION',
      },
      {
        key: 'send_kivo_notification_on_no_engagement',
        name: 'Send Kivo Chat Notification on No Engagement',
        attributeI18nKey: 'SEND_KIVO_NOTIFICATION_ON_NO_ENGAGEMENT',
      },
      {
        key: 'send_attachment',
        name: 'Send Attachment',
        attributeI18nKey: 'SEND_ATTACHMENT',
      },
      {
        key: 'add_macro',
        name: 'Add a macro',
        attributeI18nKey: 'ADD_MACRO',
      },
      {
        key: 'add_contact_label',
        name: 'Add a label to contact',
        attributeI18nKey: 'ADD_CONTACT_LABEL',
      },
      {
        key: 'remove_contact_label',
        name: 'Remove a label from contact',
        attributeI18nKey: 'REMOVE_CONTACT_LABEL',
      },
    ],
  },
  // contact_created: {
  //   conditions: [
  //     {
  //       key: 'status',
  //       name: 'Status',
  //       attributeI18nKey: 'STATUS',
  //       inputType: 'multi_select',
  //       filterOperators: OPERATOR_TYPES_1,
  //     },
  //     {
  //       key: 'browser_language',
  //       name: 'Browser Language',
  //       attributeI18nKey: 'BROWSER_LANGUAGE',
  //       inputType: 'search_select',
  //       filterOperators: OPERATOR_TYPES_1,
  //     },
  //     {
  //       key: 'mail_subject',
  //       name: 'Email Subject',
  //       attributeI18nKey: 'MAIL_SUBJECT',
  //       inputType: 'plain_text',
  //       filterOperators: OPERATOR_TYPES_2,
  //     },
  //     {
  //       key: 'country_code',
  //       name: 'Country',
  //       attributeI18nKey: 'COUNTRY_NAME',
  //       inputType: 'search_select',
  //       filterOperators: OPERATOR_TYPES_1,
  //     },
  //     {
  //       key: 'phone_number',
  //       name: 'Phone Number',
  //       attributeI18nKey: 'PHONE_NUMBER',
  //       inputType: 'plain_text',
  //       filterOperators: OPERATOR_TYPES_6,
  //     },
  //     {
  //       key: 'referer',
  //       name: 'Referrer Link',
  //       attributeI18nKey: 'REFERER_LINK',
  //       inputType: 'plain_text',
  //       filterOperators: OPERATOR_TYPES_2,
  //     },
  //     {
  //       key: 'email',
  //       name: 'Email',
  //       attributeI18nKey: 'EMAIL',
  //       inputType: 'plain_text',
  //       filterOperators: OPERATOR_TYPES_2,
  //     },
  //     {
  //       key: 'inbox_id',
  //       name: 'Inbox',
  //       attributeI18nKey: 'INBOX',
  //       inputType: 'multi_select',
  //       filterOperators: OPERATOR_TYPES_1,
  //     },
  //     {
  //       key: 'conversation_language',
  //       name: 'Conversation Language',
  //       attributeI18nKey: 'CONVERSATION_LANGUAGE',
  //       inputType: 'multi_select',
  //       filterOperators: OPERATOR_TYPES_1,
  //     },
  //     {
  //       key: 'priority',
  //       name: 'Priority',
  //       attributeI18nKey: 'PRIORITY',
  //       inputType: 'multi_select',
  //       filterOperators: OPERATOR_TYPES_1,
  //     },
  //   ],
  //   actions: [
  //     {
  //       key: 'assign_agent',
  //       name: 'Assign to agent',
  //       attributeI18nKey: 'ASSIGN_AGENT',
  //     },
  //     {
  //       key: 'assign_team',
  //       name: 'Assign a team',
  //       attributeI18nKey: 'ASSIGN_TEAM',
  //     },
  //     {
  //       key: 'assign_agent',
  //       name: 'Assign an agent',
  //       attributeI18nKey: 'ASSIGN_AGENT',
  //     },
  //     {
  //       key: 'send_email_to_team',
  //       name: 'Send an email to team',
  //       attributeI18nKey: 'SEND_EMAIL_TO_TEAM',
  //     },
  //     {
  //       key: 'send_message',
  //       name: 'Send a message',
  //       attributeI18nKey: 'SEND_MESSAGE',
  //     },
  //     {
  //       key: 'send_email_transcript',
  //       name: 'Send an email transcript',
  //       attributeI18nKey: 'SEND_EMAIL_TRANSCRIPT',
  //     },
  //     {
  //       key: 'mute_conversation',
  //       name: 'Mute conversation',
  //       attributeI18nKey: 'MUTE_CONVERSATION',
  //     },
  //     {
  //       key: 'snooze_conversation',
  //       name: 'Snooze conversation',
  //       attributeI18nKey: 'MUTE_CONVERSATION',
  //     },
  //     {
  //       key: 'resolve_conversation',
  //       name: 'Resolve conversation',
  //       attributeI18nKey: 'RESOLVE_CONVERSATION',
  //     },
  //     {
  //       key: 'send_webhook_event',
  //       name: 'Send Webhook Event',
  //       attributeI18nKey: 'SEND_WEBHOOK_EVENT',
  //     },
  //     {
  //       key: 'send_attachment',
  //       name: 'Send Attachment',
  //       attributeI18nKey: 'SEND_ATTACHMENT',
  //     },
  //     {
  //       key: 'add_macro',
  //       name: 'Add a macro',
  //       attributeI18nKey: 'ADD_MACRO',
  //     }, 
  //   ],
  // },
  call_ended: {
    conditions: [
      {
        key: 'call_status',
        name: 'Call status',
        attributeI18nKey: 'CALL_STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'call_direction',
        name: 'Call direction',
        attributeI18nKey: 'CALL_DIRECTION',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'call_status_reason',
        name: 'Call status reason',
        attributeI18nKey: 'CALL_STATUS_REASON',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'status',
        name: 'Status',
        attributeI18nKey: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_id',
        name: 'Inbox',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'board_id',
        name: 'Board',
        attributeI18nKey: 'BOARD',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'Phone Number',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'lead_quality_score',
        name: 'Lead quality score',
        attributeI18nKey: 'LEAD_QUALITY_SCORE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_LEAD_QUALITY_SCORE,
        featureFlag: 'lead_quality',
      },
    ],
    actions: [
      {
        key: 'add_macro',
        name: 'Add a macro',
        attributeI18nKey: 'ADD_MACRO',
      },
      {
        key: 'send_message',
        name: 'Send a message',
        attributeI18nKey: 'SEND_MESSAGE',
      },
      {
        key: 'assign_agent',
        name: 'Assign to agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'Assign a team',
        attributeI18nKey: 'ASSIGN_TEAM',
      },
      {
        key: 'add_contact_label',
        name: 'Add a label to contact',
        attributeI18nKey: 'ADD_CONTACT_LABEL',
      },
      {
        key: 'add_conversation_label',
        name: 'Add a label to conversation',
        attributeI18nKey: 'ADD_LABEL',
      },
      {
        key: 'send_webhook_event',
        name: 'Send Webhook Event',
        attributeI18nKey: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_kivo_notification',
        name: 'Send Kivo Chat Notification',
        attributeI18nKey: 'SEND_KIVO_NOTIFICATION',
      },
      {
        key: 'resolve_conversation',
        name: 'Resolve conversation',
        attributeI18nKey: 'RESOLVE_CONVERSATION',
      },
    ],
  },
  whatsapp_flow_submitted: {
    conditions: [
      {
        key: 'whatsapp_flow_id',
        name: 'Flow ID',
        attributeI18nKey: 'WHATSAPP_FLOW',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_id',
        name: 'Inbox',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'status',
        name: 'Status',
        attributeI18nKey: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'board_id',
        name: 'Board',
        attributeI18nKey: 'BOARD',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'Phone Number',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'conversation_labels',
        name: 'Labels',
        attributeI18nKey: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'lead_quality_score',
        name: 'Lead quality score',
        attributeI18nKey: 'LEAD_QUALITY_SCORE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_LEAD_QUALITY_SCORE,
        featureFlag: 'lead_quality',
      },
    ],
    actions: [
      {
        key: 'send_message',
        name: 'Send a message',
        attributeI18nKey: 'SEND_MESSAGE',
      },
      {
        key: 'send_whatsapp_template',
        name: 'Send WhatsApp template',
        attributeI18nKey: 'SEND_WHATSAPP_TEMPLATE',
      },
      {
        key: 'assign_agent',
        name: 'Assign to agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'Assign a team',
        attributeI18nKey: 'ASSIGN_TEAM',
      },
      {
        key: 'add_contact_label',
        name: 'Add a label to contact',
        attributeI18nKey: 'ADD_CONTACT_LABEL',
      },
      {
        key: 'add_conversation_label',
        name: 'Add a label to conversation',
        attributeI18nKey: 'ADD_LABEL',
      },
      {
        key: 'remove_contact_label',
        name: 'Remove a label from contact',
        attributeI18nKey: 'REMOVE_CONTACT_LABEL',
      },
      {
        key: 'remove_conversation_label',
        name: 'Remove a label from conversation',
        attributeI18nKey: 'REMOVE_CONVERSATION_LABEL',
      },
      {
        key: 'send_webhook_event',
        name: 'Send Webhook Event',
        attributeI18nKey: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_email_to_team',
        name: 'Send an email to team',
        attributeI18nKey: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'add_macro',
        name: 'Add a macro',
        attributeI18nKey: 'ADD_MACRO',
      },
      {
        key: 'send_attachment',
        name: 'Send Attachment',
        attributeI18nKey: 'SEND_ATTACHMENT',
      },
      {
        key: 'resolve_conversation',
        name: 'Resolve conversation',
        attributeI18nKey: 'RESOLVE_CONVERSATION',
      },
    ],
  },
};

export const CALL_STATUS_CONDITION_VALUES = [
  { id: 'missed', name: 'Missed' },
  { id: 'answered', name: 'Answered' },
  { id: 'failed', name: 'Failed' },
];

export const CALL_DIRECTION_CONDITION_VALUES = [
  { id: 'inbound', name: 'Inbound' },
  { id: 'outbound', name: 'Outbound' },
];

export const CALL_STATUS_REASON_CONDITION_VALUES = [
  { id: 'chanunavail', name: 'chanunavail' },
  { id: 'cancel', name: 'cancel' },
  { id: 'disconnected_by_callee', name: 'disconnected_by_callee' },
  { id: 'disconnected_by_caller', name: 'disconnected_by_caller' },
  { id: 'noanswer', name: 'noanswer' },
  { id: 'normal_clearing', name: 'Normal Clearing' },
];

/** Shared condition — injected into every automation event in methodsMixin */
export const REENGAGEMENT_COUNT_CONDITION = {
  key: 'reengagement_count',
  name: 'Reengagement count',
  attributeI18nKey: 'REENGAGEMENT_COUNT',
  inputType: 'plain_text',
  filterOperators: OPERATOR_TYPES_LEAD_QUALITY_SCORE,
};

export const AUTOMATION_RULE_EVENTS = [
  {
    key: 'conversation_created',
    value: 'Conversation Created',
  },
  {
    key: 'conversation_updated',
    value: 'Conversation Updated',
  },
  {
    key: 'message_created',
    value: 'Message Created',
  },
  {
    key: 'conversation_opened',
    value: 'Conversation Opened',
  },
  {
    key: 'board_status_change',
    value: 'Pipeline Changed',
  },
  {
    key: 'lead_quality_score_generated',
    value: 'Lead quality score generated or updated',
    featureFlag: 'lead_quality',
  },
  {
    key: 'contact_joined_meeting',
    value: 'Contact Joined Meeting',
  },
  {
    key: 'call_ended',
    value: 'Call Ended',
  },
  {
    key: 'whatsapp_flow_submitted',
    value: 'WhatsApp Flow Form Submitted',
  },
  // {
  //   key: 'contact_created',
  //   value: 'Contact Created',
  // },
];

export const AUTOMATION_ACTION_TYPES = [
  {
    key: 'assign_agent',
    label: 'Assign to agent',
    inputType: 'search_select',
  },
  {
    key: 'assign_team',
    label: 'Assign a team',
    inputType: 'search_select',
  },
  {
    key: 'add_conversation_label',
    label: 'Add a label to conversation',
    inputType: 'multi_select',
  },
  {
    key: 'add_contact_label',
    label: 'Add a label to contact',
    inputType: 'multi_select',
  },
  {
    key: 'remove_conversation_label',
    label: 'Remove a label from conversation',
    inputType: 'multi_select',
  },
  {
    key: 'remove_contact_label',
    label: 'Remove a label from contact',
    inputType: 'multi_select',
  },
  {
    key: 'send_email_to_team',
    label: 'Send an email to team',
    inputType: 'team_message',
  },
  {
    key: 'send_email_transcript',
    label: 'Send an email transcript',
    inputType: 'email',
  },
  {
    key: 'mute_conversation',
    label: 'Mute conversation',
    inputType: null,
  },
  {
    key: 'snooze_conversation',
    label: 'Snooze conversation',
    inputType: null,
  },
  {
    key: 'resolve_conversation',
    label: 'Resolve conversation',
    inputType: null,
  },
  {
    key: 'send_webhook_event',
    label: 'Send Webhook Event',
    inputType: 'url',
  },
  {
    key: 'send_kivo_notification',
    label: 'Send Kivo Chat Notification',
    inputType: 'kivo_webhook',
  },
  {
    key: 'send_kivo_notification_on_no_engagement',
    label: 'Send Kivo Chat Notification on No Engagement',
    inputType: 'kivo_no_engagement_webhook',
  },
  {
    key: 'send_attachment',
    label: 'Send Attachment',
    inputType: 'attachment',
  },
  {
    key: 'send_message',
    label: 'Send a message',
    inputType: 'textarea',
  },
  {
    key: 'change_priority',
    label: 'Change Priority',
    inputType: 'search_select',
  },
  {
    key: 'gather_lead_quality_score',
    label: 'Gather lead quality score',
    inputType: null,
    featureFlag: 'lead_quality',
  },
  {
    key: 'add_macro',
    label: 'Add a macro',
    inputType: 'multi_select',
  },
  {
    key: 'add_board',
    label: 'Add a Board',
    inputType: 'search_select',
  },
  {
    key: 'send_ai_generated_email',
    label: 'Send AI Generated Email',
    inputType: 'ai_generated_email',
  },
  {
    key: 'send_whatsapp_template',
    label: 'Send WhatsApp Template',
    inputType: 'send_whatsapp_template',
  },
];

// Keep in sync with ActionService wait clamp for send_kivo_notification_on_no_engagement.
export const KIVO_NO_ENGAGEMENT_WAIT_MINUTES = {
  DEFAULT: 10,
  MIN: 1,
  MAX: 10080, // 7 days
};

export const normalizeKivoNoEngagementWaitMinutes = value => {
  const wait = Number(value);
  if (
    !Number.isFinite(wait) ||
    wait < KIVO_NO_ENGAGEMENT_WAIT_MINUTES.MIN
  ) {
    return KIVO_NO_ENGAGEMENT_WAIT_MINUTES.DEFAULT;
  }
  return Math.min(
    Math.floor(wait),
    KIVO_NO_ENGAGEMENT_WAIT_MINUTES.MAX
  );
};

// Keep in sync with ActionService macro delay clamp for add_macro.
export const MACRO_DELAY_MINUTES = {
  MIN: 1,
  MAX: 10080, // 7 days
};

export const normalizeMacroDelayMinutes = value => {
  const delay = Number(value);
  if (!Number.isFinite(delay) || delay <= 0) return 0;
  return Math.min(Math.floor(delay), MACRO_DELAY_MINUTES.MAX);
};
